import Layers from "slotworks/graphics/layers/layers";
import BetModel from "slotworks/model/bets/bet-model";
import { Services } from "slotworks/services/services";
import AbstractStepperControl from "slotworks/smart-ui/controls/abstract/abstract-stepper-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import smartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class TotalStakeStepperControl extends AbstractStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], SmartUIGroup: smartUIGroup) {
        super.setup(name, layer, assetName, assetNames, SmartUIGroup);

        this.stepperComponent.formatFunction = formatMoneyAsCurrency;
        this.stepperComponent.onUpdate.add(this.onStepperUpdated);
    }

    public updateOptions(options: ControlOptions) {
        this.options = options;

        if (!this.setupData) {
            this.setupValues(options.getTotalStakeValues(), options.getTotalStake());
            this.setupData = true;
        } else {
            this.setSelectedValue(options.getTotalStake());
        }

        if (BetModel.freeBet) {
            this.stepperComponent.formatFunction = () => Services.translations.get("free");
            this.stepperComponent.setEnabled(false);
        } else {
            this.stepperComponent.formatFunction = formatMoneyAsCurrency;
            this.stepperComponent.setEnabled(this.enabled);
        }
        this.stepperComponent.update();
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        // Never enable stepper during free bets
        if (BetModel.freeBet) {
            this.stepperComponent.setEnabled(false);
        }
    }

    private onStepperUpdated = (value: number) => {
        const options = new ControlOptions();
        options.creditSizes = this.options.creditSizes.clone();
        options.selectedLines = this.options.selectedLines;
        options.creditsPerLine = this.options.creditsPerLine.clone();
        options.fixedBetCost = this.options.fixedBetCost;

        options.setTotalStake(value);

        this.onChange.dispatch(options);
    }
}
